import type { ButtonType } from "@similarweb/ui-components";
import { PopupClickContainer, PopupHoverContainer, IconButton } from "@similarweb/ui-components";

import { i18nFilter } from "app/filters/i18nFilter";
import I18n from "pro-features/components/WithTranslation/src/I18n";

import {
    DashboardTemplatesPromotionTooltipContent,
    DashboardTemplatesPromotionTooltipTitle,
    DashboardTemplatesPromotionTooltipText,
} from "../style/NotificationButton.styled";
import "../style/NotificationButton.scss";

import type { JSX, MouseEvent } from "react";

interface INotificationButtonProps {
    isDisabled?: boolean;
    isLoading?: boolean;
    isActivated?: boolean;
    onClick?: (event?: MouseEvent) => void;
    toolTipText?: string;
    promotionTooltip?: boolean;
    btnType?: ButtonType;
}

const getTemplatesPromotionTooltip = () => {
    return (
        <DashboardTemplatesPromotionTooltipContent>
            <DashboardTemplatesPromotionTooltipTitle>
                <I18n>home.page.dashboard.promotion.tooltip.notifications.title</I18n>
            </DashboardTemplatesPromotionTooltipTitle>
            <DashboardTemplatesPromotionTooltipText>
                <I18n>home.page.dashboard.promotion.tooltip.notifications.body</I18n>
            </DashboardTemplatesPromotionTooltipText>
        </DashboardTemplatesPromotionTooltipContent>
    );
};
export const NotificationButton = ({
    isActivated = false,
    onClick,
    isDisabled,
    promotionTooltip,
    toolTipText,
    btnType = "flat",
}: INotificationButtonProps): JSX.Element => {
    const buttonText = isActivated
        ? i18nFilter()("dashboard.dashboardSubscription.subscribeButtonText.SUBSCRIBED")
        : i18nFilter()("dashboard.dashboardSubscription.subscribeButtonText.SUBSCRIBE");
    const buttonIcon = isActivated ? "checked" : "mail";
    const getToolTipText = (text: string | undefined) =>
        function () {
            return <div>{text}</div>;
        };
    const handleClick = (): void => {
        onClick?.();
    };
    const buttonComponent = promotionTooltip ? (
        <PopupClickContainer
            content={getTemplatesPromotionTooltip}
            config={{
                enabled: true,
                defaultOpen: true,
                placement: "bottom",
                allowHover: true,
                cssClass: "Popup-element-wrapper--pro dashboardTemplatePromote-popup",
            }}
        >
            <div data-automation="subscribe-button">
                <IconButton
                    iconName={buttonIcon}
                    type={btnType}
                    isDisabled={isDisabled}
                    onClick={handleClick}
                >
                    {buttonText}{" "}
                </IconButton>
            </div>
        </PopupClickContainer>
    ) : (
        <div data-automation="subscribe-button">
            <IconButton
                iconName={buttonIcon}
                type={btnType}
                isDisabled={isDisabled}
                onClick={handleClick}
            >
                {buttonText}{" "}
            </IconButton>
        </div>
    );

    const ButtonComponentWithToolTip = !promotionTooltip ? (
        <PopupHoverContainer
            content={getToolTipText(toolTipText)}
            config={{
                maxWidth: 185,
                enabled: true,
                placement: "bottom",
                allowHover: true,
                cssClass: "Popup-element-wrapper--pro notificationButton-popup",
            }}
        >
            <div>{buttonComponent}</div>
        </PopupHoverContainer>
    ) : (
        buttonComponent
    );

    return toolTipText ? ButtonComponentWithToolTip : buttonComponent;
};
